import 'css-chunksrc/client/scenes/optimizedGantt/header/delayToggle/styles.scss';export default {
  "delayToggle": "_delayToggle_4si62_1",
  "icon": "_icon_4si62_10",
  "text": "_text_4si62_16"
};